// extracted by mini-css-extract-plugin
export default {"container":"AdminDashboard_container__AKxSn","header":"AdminDashboard_header__5ZvKP","logoutButton":"AdminDashboard_logoutButton__GbRhV"};